import { useCallback } from 'react';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { RfqMarkPrice } from '@paradigm/features/src/unified-rfqs/ui/rfq-websocket/mark-price-context';
import { Status } from '@paradigm/features/src/unified-rfqs/ui/one-click-trade/types';
import {
  AuctionType,
  Side,
} from '@paradigm/features/src/unified-rfqs/entities/shared';

interface SubmitOrderTrackArgs {
  auctionType: AuctionType;
  side: Side;
  price: string | undefined;
  isMarkOrBetterFn: RfqMarkPrice['isMarkOrBetter'];
  status: Status;
}

export function useSubmitOrderTracker({
  auctionType,
  side,
  price,
  isMarkOrBetterFn,
  status,
}: SubmitOrderTrackArgs) {
  const track = useTrackAction();
  return useCallback(() => {
    const args = {
      auctionType,
      side,
      price,
    };
    if (status === 'idle') track('1-click trade', args);
    if (status === 'confirming')
      track('confirm 1-click trade', {
        ...args,
        isMarkOrBetter: isMarkOrBetterFn(price, side),
      });
  }, [auctionType, isMarkOrBetterFn, price, side, status, track]);
}
